import React from 'react';
import PropTypes from 'prop-types';
import {
  isMobile,
  isBrowser
  } from "react-device-detect";

import { ProgressBar } from 'react-bootstrap';


import '../../css/GradientSVGStyle.css' 

class CircularProgressBar extends React.Component {
    constructor(props) {
      super(props);
      this.state = {};
    }
  
    render() {
      // Size of the enclosing square
      const sqSize = this.props.sqSize;
      // SVG centers the stroke width on the radius, subtract out so circle fits in square
      const radius = (this.props.sqSize - this.props.strokeWidth) / 2;
      // Enclose cicle in a circumscribing square
      const viewBox = `0 0 ${sqSize} ${sqSize}`;
      // Arc length at 100% coverage is the circle circumference
      const dashArray = radius * Math.PI * 2;
      // Scale 100% coverage overlay with the actual percent
      const dashOffset = dashArray - dashArray * this.props.percentage / 100;
      return (
        <svg
            width={this.props.sqSize}
            height={this.props.sqSize}
            viewBox={viewBox}
            style={{fill: "none"}}>
            <circle
              className="circle-background"
              style={{stroke:" #ddd"}}
              cx={this.props.sqSize / 2}
              cy={this.props.sqSize / 2}
              r={radius}
              strokeWidth={`${this.props.strokeWidth}px`} />
            <circle
              className="circle-progress"
              cx={this.props.sqSize / 2}
              cy={this.props.sqSize / 2}
              r={radius}
              strokeWidth={`${this.props.strokeWidth}px`}
              // Start progress marker at 12 O'Clock
              transform={`rotate(-90 ${this.props.sqSize / 2} ${this.props.sqSize / 2})`}
              style={{
                strokeDasharray: dashArray, strokeDashoffset: dashOffset,stroke: 'green'
              }} />
            <text
              className="circle-text"
              style={{fontSize: "13px", fill: "#212529"}}
              x="50%"
              y="50%"
              dy=".3em"
              textAnchor="middle">
              {`${this.props.percentage +"%"}`}
            </text>
        </svg>
      );
    }
  }

  const ScoreWheel = function(props) {
    
      //let scorePercentage = props.score;
      //let scoreValue = 629 * (props.score/100);
      console.log('isMobile-',isMobile);
      
    if (isMobile) {
        let bsStyleVal  =   "danger";
        if(props.score < 50 && props.score >= 25)
             bsStyleVal  =   "warning";
        if(props.score < 75 && props.score >= 50)
            bsStyleVal  =   "info";     
        if(props.score >= 75)
            bsStyleVal  =   "success";   

        return <div style={{paddingTop:'5px'}} >
            <ProgressBar  style={{marginTop:'1px'}} bsStyle={bsStyleVal} className="barCatStyle"  
            label={+props.score+"%"}  id={"id-"+props.title}  now={props.score} >
            </ProgressBar></div>
        }
    if (isBrowser) {
        return (
                <div>
                <ul>
                {/*
                
                <li data-name={props.title} data-percent={scorePercentage} alt={scorePercentage} title={props.title}>
                    <svg  viewBox="-10 -10 220 220" preserveAspectRatio="xMidYMid meet">
                        <g fill="none" strokeWidth="16" transform="translate(100,100)">
                        <path d="M 0,-100 A 100,100 0 0,1 86.6,-50" stroke="url(#cl1)"/>
                        <path d="M 86.6,-50 A 100,100 0 0,1 86.6,50" stroke="url(#cl2)"/>
                        <path d="M 86.6,50 A 100,100 0 0,1 0,100" stroke="url(#cl3)"/>
                        <path d="M 0,100 A 100,100 0 0,1 -86.6,50" stroke="url(#cl4)"/>
                        <path d="M -86.6,50 A 100,100 0 0,1 -86.6,-50" stroke="url(#cl5)"/>
                        <path d="M -86.6,-50 A 100,100 0 0,1 0,-100" stroke="url(#cl6)"/>
                        </g>
                    </svg>
                    <svg  viewBox="-10 -10 220 220" preserveAspectRatio="xMidYMid meet">
                        <path d="M200,100 C200,44.771525 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z" strokeDashoffset={scoreValue}></path>
                    </svg>
                </li>*/}
                    <CircularProgressBar
                        strokeWidth="5"
                        sqSize="50"
                        percentage={props.score}/>
                    <p style={{fontWeight:"400",fontSize: "12px" }}>{props.title}</p>
            </ul>
        

       {/* <svg width="0" height="0">
        <defs>
        <linearGradient id="cl1" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor={props.colorOne}/>
            <stop offset="100%" stopColor={props.colorOne}/>
        </linearGradient>
        <linearGradient id="cl2" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor={props.colorOne}/>
            <stop offset="100%" stopColor={props.colorTwo}/>
        </linearGradient>
        <linearGradient id="cl3" gradientUnits="objectBoundingBox" x1="1" y1="0" x2="0" y2="1">
            <stop stopColor={props.colorTwo}/>
            <stop offset="100%" stopColor={props.colorTwo}/>
        </linearGradient>
        <linearGradient id="cl4" gradientUnits="objectBoundingBox" x1="1" y1="1" x2="0" y2="0">
            <stop stopColor={props.colorTwo}/>
            <stop offset="100%" stopColor={props.colorThree}/>
        </linearGradient>
        <linearGradient id="cl5" gradientUnits="objectBoundingBox" x1="0" y1="1" x2="0" y2="0">
            <stop stopColor={props.colorThree}/>
            <stop offset="100%" stopColor={props.colorThree}/>
        </linearGradient>
        <linearGradient id="cl6" gradientUnits="objectBoundingBox" x1="0" y1="1" x2="1" y2="0">
            <stop stopColor={props.colorThree}/>
            <stop offset="100%" stopColor={props.colorThree}/>
        </linearGradient>
        </defs>
        </svg>*/}
        </div>
        );
     
    }
    
  }
  ScoreWheel.propTypes = {
    title: PropTypes.string.isRequired,
    score: PropTypes.number,
    colorOne:PropTypes.string.isRequired,
    colorTwo:PropTypes.string.isRequired,
    colorThree:PropTypes.string.isRequired,
    };

    ScoreWheel.defaultProps = {
    title: "NoTitle"
  };
  
  export default ScoreWheel;
